import { memo } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import APPConf from '../../lib/config/common';

const Footer = () => {
  const today = new Date();
  const yyyy = today.getFullYear();

  return (
    <footer className='footer-container'>
      <Row>
        <Col md={ 7 }>
          { /* <a href='#'>Terms of Policy</a> | &nbsp;  // Временно скрыл. Потом тут вставим ссылки на наши документы.
          <a href='#'>Cookie</a> | &nbsp;
<a href='#'>Privacy</a> */ }
        </Col>
        <Col md={ 5 }>
          <span className='muted float-end'>
            © { yyyy }. All rights reserved. Версия: { APPConf.version }
          </span>
        </Col>
      </Row>
    </footer>
  );
};

export default memo(Footer);
